<template>
  <offer-layout>
    <error @click="logout">
      <heading level="2" class="title" slot="title">{{ t('title') }}</heading>
      <i18n class="message" path="errors.emailDeclined.message" tag="div" slot="message">
        <brand-link
          :href="phoneNumberLink"
          class="phoneNumber"
          slot="phoneNumber"
          v-text="phoneNumber"
        />
        <span slot="workHours">{{ workHours }}</span>
      </i18n>
      <span class="buttonLabel" slot="buttonLabel">{{ t('buttonLabel') }}</span>
    </error>
  </offer-layout>
</template>
<script>
import OfferLayout from '@/views/layouts/OfferLayout';
import Error from '@/components/Error';
import buildTranslators from '@/utils/build-translators';

const INELIGIBLE_REASONS = ['ODL Duplicate Check', 'App Residency Status', 'Account Risk Status'];

export default {
  components: {
    OfferLayout,
    Error,
  },
  data() {
    return {
      phoneNumber: this.$env.VUE_APP_PARTNER_PHONE,
      workHours: this.$env.VUE_APP_PARTNER_WORK_HOURS,
      declineReasons: this.$store.getters['offer/getDeclineReasons'] || [],
    };
  },
  async created() {
    if (this.declineReasons.length > 0) {
      const [declineReason] = this.declineReasons;
      if (INELIGIBLE_REASONS.includes(declineReason.ruleName)) {
        this.$router.replace({ name: 'ineligibletl' });
      }
    }
  },
  computed: {
    phoneNumberLink() {
      return `tel://${this.phoneNumber}`;
    },
  },
  methods: {
    async logout() {
      await this.$auth.logOut();
    },
    t(key, options) {
      return buildTranslators('errors.emailDeclined').t(key, options);
    },
  },
};
</script>
<style lang="sass" scoped></style>
